import React, { Component } from "react";
import moment from "moment";

// Components
import "./style.css";

class ChurchVisitingHours extends Component {
    renderOpeningHours(data) {
        return data.map((data, index) => {
            const openingHour = moment
                .parseZone(data.klokkeslett[0].greaterThanOrEqualTo)
                .format("HH:mm");
            const closingHour = moment
                .parseZone(data.klokkeslett[0].lessThanOrEqualTo)
                .format("HH:mm");
            let days = [
                data.mandag ? "mandag" : "",
                data.tirsdag ? "tirsdag" : "",
                data.onsdag ? "onsdag" : "",
                data.torsdag ? "torsdag" : "",
                data.fredag ? "fredag" : "",
                data.lordag ? "lørdag" : "",
                data.sondag ? "søndag" : "",
            ].filter((item) => item !== "");

            const stringDays = days.map((item, i) => {
                if (i === days.length - 1 && days.length > 1)
                    return ` og ${item}`;
                return i === 0 ? item : `, ${item}`;
            });

            return (
                <div key={index}>
                    Kirken er åpen fra {openingHour} til {closingHour} hver{" "}
                    {stringDays}
                </div>
            );
        });
    }

    render() {
        const {
            openChurch,
            fromDateTime,
            toDateTime,
            openChurchInfoNorwegian,
            contactPerson,
            contactPersonPhone,
        } = this.props.church;

        if (
            [
                openChurch,
                fromDateTime,
                toDateTime,
                openChurchInfoNorwegian,
                contactPerson,
                contactPersonPhone,
            ].every((prop) => prop === undefined || prop === null )
        ) {
            return null;
        }
        // const textInsteadOfHours =
        //     openingHours.length === 0 && comment !== "" ? (
        //         <p>{comment}</p>
        //     ) : openingHours.length === 0 ? (
        //         <p>Kontakt kirkelig fellesråd.</p>
        //     ) : (
        //         ""
        //     );

        return (
            <div className="church-facts__wrapper church-facts__wrapper--redlight">
                <div className="church-facts__inner">
                    <h3 className="church-facts__title">Åpen kirke</h3>

                    <div className="church-facts__content">
                        {openChurch && (
                            <p>
                                <strong>Åpen kirke: </strong>
                                <br />
                                {openChurch}
                            </p>
                        )}
                        {fromDateTime && toDateTime && (
                            <p>
                                <strong>Periode: </strong>
                                <br />
                                {
                                    <div className="church-facts__opening-hours">
                                        <div>{`${moment(fromDateTime).format(
                                            "DD.MM.YYYY"
                                        )} - ${moment(toDateTime).format(
                                            "DD.MM.YYYY"
                                        )}`}</div>
                                    </div>
                                }
                            </p>
                        )}
                        {openChurchInfoNorwegian && (
                            <p>
                                <strong>Åpningstid: </strong>
                                <br />
                                {openChurchInfoNorwegian}
                            </p>
                        )}
                        {(contactPerson || contactPersonPhone) && (
                            <p>
                                <strong>Kontaktperson åpen kirke: </strong>
                                <br />
                                {contactPerson ? contactPerson : ""}
                                <br />
                                {contactPersonPhone ? contactPersonPhone : ""}
                            </p>
                        )}

                        {/* {textInsteadOfHours !== "" && textInsteadOfHours} */}
                        {/* {openingHours.map((data, index) => {
                            const fromDate = moment(
                                data.dato.greaterThanOrEqualTo
                            ).format("DD.MM.YYYY");
                            const toDate = moment(
                                data.dato.lessThanOrEqualTo
                            ).format("DD.MM.YYYY");
                            return (
                                <div
                                    key={index}
                                    className="church-facts__opening-hours"
                                >
                                    <div>{`${fromDate} - ${toDate}`}</div>
                                    {data && data.beskrivelse && (
                                        <div>{data.beskrivelse}</div>
                                    )}
                                    {this.renderOpeningHours(
                                        data.ukedagerogklokkeslett
                                    )}
                                </div>
                            );
                        })} */}
                        {/* {contactPersons.length !== 0 && (
                            <h3 className="church-facts__contact-title">
                                Kontakt
                            </h3>
                        )}
                        {contactPersons.map((data, index) => {
                            return (
                                <p key={index}>
                                    <strong>
                                        {data.fornavn} {data.etternavn}
                                    </strong>
                                    <br />
                                    {data.telefon && (
                                        <a href={`tel:${data.telefon}`}>
                                            {data.telefon}
                                            <br />
                                        </a>
                                    )}
                                    {data.epost && (
                                        <a href={`mailto:${data.epost}`}>
                                            {data.epost}
                                        </a>
                                    )}
                                </p>
                            );
                        })} */}
                    </div>
                </div>
            </div>
        );
    }
}

export default ChurchVisitingHours;



// WEBPACK FOOTER //
// ./src/components/ChurchVisitingHours/index.js